var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8 25.5H23V13H8V25.5ZM15.5 16.75C16.875 16.75 18 17.875 18 19.25C18 20.625 16.875 21.75 15.5 21.75C14.125 21.75 13 20.625 13 19.25C13 17.875 14.125 16.75 15.5 16.75Z",
    fill: "#837FD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.5H21.75V8C21.75 4.55 18.95 1.75 15.5 1.75C12.05 1.75 9.25 4.55 9.25 8V10.5H8C6.625 10.5 5.5 11.625 5.5 13V25.5C5.5 26.875 6.625 28 8 28H23C24.375 28 25.5 26.875 25.5 25.5V13C25.5 11.625 24.375 10.5 23 10.5ZM11.75 8C11.75 5.925 13.425 4.25 15.5 4.25C17.575 4.25 19.25 5.925 19.25 8V10.5H11.75V8ZM23 25.5H8V13H23V25.5ZM15.5 21.75C16.875 21.75 18 20.625 18 19.25C18 17.875 16.875 16.75 15.5 16.75C14.125 16.75 13 17.875 13 19.25C13 20.625 14.125 21.75 15.5 21.75Z",
    fill: "#837FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0a087d589fa377ad257408f81cc05da5.svg";
export { ForwardRef as ReactComponent };